import { useEffect } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Tattoo from "@/components/Tattoo";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import Booking from "@/components/Booking";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payment = params.get("payment");
    const sessionId = params.get("session_id");
    if (payment === "success" && sessionId) {
      api.get(`/payments/status/${sessionId}`)
        .then((res) => {
          if (res.data.payment_status === "paid") toast.success("Acompte payé — votre rendez-vous est confirmé !");
          else toast.info("Paiement reçu, validation en cours…");
        })
        .catch(() => toast.info("Paiement reçu, validation en cours…"));
      window.history.replaceState({}, "", "/");
      setTimeout(() => document.querySelector("#reservation")?.scrollIntoView({ behavior: "smooth" }), 600);
    } else if (payment === "cancelled") {
      toast.error("Paiement annulé — votre demande reste en attente d'acompte.");
      window.history.replaceState({}, "", "/");
      setTimeout(() => document.querySelector("#reservation")?.scrollIntoView({ behavior: "smooth" }), 600);
    }
  }, []);

  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Tattoo />
      <Gallery />
      <Manifesto />
      <Testimonials />
      <Booking />
      <Contact />
      <Footer />
    </main>
  );
}
